import { Box, Typography } from "@mui/material";
import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch, useSelector } from "react-redux";
import { deleteFile, DownloadFile } from "./defineSlice";

export default function Attachments() {
	const dispatch = useDispatch();
	const State = useSelector((store) => store.define);
	const { files } = State;

	function handleDeleteFile(file) {
		console.log(file);
		dispatch(deleteFile(file));
	}
	function handleDownloadFile(file) {
		const url = URL.createObjectURL(file); 
		const link = document.createElement('a'); 
		link.href = url; 
		link.setAttribute('download', file.name); 
		document.body.appendChild(link); 
		link.click(); 
		link.parentNode.removeChild(link); 
		URL.revokeObjectURL(url);
	}
	return (
		<Box sx={{ mt: 2 }}>
			{" "}
			<Box
				sx={{
					height: "auto",
					pt: 1.4,
					borderRadius: 2,
				}}
			>
				{/* <Typography sx={{
					mt: -7,
					mb: 4,
					fontWeight: 600,
				}}>
                  Attachments
               </Typography> */}
				{/* <Typography sx={{ fontWeight: "bold" }}>Attachments</Typography>{" "} */}
				<List dense={false}>
					{files.map((file, index) => {
						return (
							<ListItem
								sx={{ mt: -3, mb: 2, }}
								key={index}
								secondaryAction={
									<>
										<IconButton sx={{ ml: -7.5, mr: 2 }}
											edge="end"
											aria-label="delete"
											onClick={() => handleDeleteFile(file)}
										>
											<DeleteIcon />
										</IconButton>
										<IconButton
											edge="start"
											aria-label="download"
											onClick={() => handleDownloadFile(file)}
											sx={{ ml: -19.5 }}
										>
											<DownloadRoundedIcon />
										</IconButton> 
									</>
								}
							>
								<ListItemAvatar>
									<Avatar sx={{ bgcolor: "darkBlue.light", }}>
										<InsertDriveFileIcon
											sx={{ color: "white", }}
										/>
									</Avatar>
								</ListItemAvatar>
								<ListItemText
									primary={file.name}
									secondary={false ? "Secondary text" : null}
								/>
							</ListItem>
						);
					})}
				</List>
			</Box>
		</Box>
	);
}
